export default __webpack_public_path__ + "static/media/logo.a5b4410c.png";